<template>
  <div class="locale-changer">


    <v-row align="center">
      <v-col>
        <v-select
          outlined
          v-model="$i18n.locale"
          class="idioma black-text"
          :items="idiomas"
          item-text="text"
          item-value="value"
          @change="setLocale"
        >
        </v-select>        

      </v-col>
    </v-row>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  
  name: 'SwitchLanguage',
  data: () =>({
        literals : [ 'català', 'castellano'],
        langs: [ 
          {
            value: 'ca',
            label: 'català'
          },
          {
            value: 'es',
            label: 'castellano'
          }
        ],
        idiomas: [
          {
            value: 'ca',
            text: 'català'
          },
          {
            value: 'es',
            text: 'castellano'
          }
        ],

  }),
  components: {
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },

  methods: {
    setLocale(locale){
/*       state.language = locale; */
      this.$i18n.locale = locale
/*       locale = state.language
      console.log(locale) */
/*       console.log('setlocale')
      console.log(locale) */
/*       console.log(language) */
      this.$router.push({
        path: `/${this.$i18n.locale}${this.$route.name}`,
/*  name: 'Enfardadores', */
        params: { lang: locale }
      })
    },
    onLanguageChange () {
      this.changeLanguage({ lang: this.lang, i18n: this.$i18n })
    },
/*     changeLanguage: function(state, locale) {
      state.language = locale;
      console.log(locale)
      console.log('locale')
      this.$i18n.locale = state.language;
      this.$router.push({
          path: `/${this.$i18n.locale}/`,
          name: '/Inici',
          params: { lang: locale }
      })
    } */
  },



}


</script>


<style scoped lang="scss">


  .flechaselect {
    color: rgb(0, 0, 0);
    position: absolute;
    right:6%;
  }

  .flechabox{
    color: rgb(0, 0, 0);
    position: absolute;
    right:6%;
    top: 15px;
    z-index: 2;
    width:1px;
  }

</style>